module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular.1e09f38c.otf";